module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTciIGhlaWdodD0iMTciIHZpZXdCb3g9IjAgMCAxNyAxNyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTguNTE1ODkgMTEuMDQ2OEwyLjU3MzgzIDE3TDAuMDMxNzc1OCAxNC40NTMyTDUuOTczODMgOC41TDAgMi41NDY4MkwyLjU0MjA2IDBMOC41MTU4OSA1Ljk1MzE5TDE0LjQ1NzkgMEwxNyAyLjU0NjgyTDExLjA1NzkgOC41TDE3IDE0LjQ1MzJMMTQuNDU3OSAxN0w4LjUxNTg5IDExLjA0NjhaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/images/icon/multiplication.svg
// module id = 13881
// module chunks = 0